export const changeCompanyFilters = selection => ({
  type: 'CHANGE_COMPANY_FILTERS',
  selection,
});
